import cn from 'classnames';

import { IConDefaultType } from '..';
import { EColorMap } from '../constants/colorMap';
import { useTheme } from 'styled-components';

export enum MenuIconVariant {
  MENU = 'menu',
  MENU_DARK = 'menu_dark',
  LIST = 'list',
  BUBBLE_CHAT = 'bubble_chat',
}
export interface IMenuIconProps extends IConDefaultType {
  variant?: MenuIconVariant;
}

function MenuIcon({ color, className, size = 24, rotate, flip, variant = MenuIconVariant.MENU }: IMenuIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === MenuIconVariant.MENU && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12Z"
            fill="#303037"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 19C3 18.4477 3.44772 18 4 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19Z"
            fill="#303037"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6H4C3.44772 6 3 5.55228 3 5Z"
            fill="#303037"
          />
          <circle cx="20" cy="5" r="2" fill={theme.color.static.primary} />
        </svg>
      )}
      {variant === MenuIconVariant.MENU_DARK && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12Z"
            fill="#ffffff"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 19C3 18.4477 3.44772 18 4 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19Z"
            fill="#ffffff"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6H4C3.44772 6 3 5.55228 3 5Z"
            fill="#ffffff"
          />
          <circle cx="20" cy="5" r="2" fill={theme.color.static.primary} />
        </svg>
      )}
      {variant === MenuIconVariant.LIST &&
        (() => {
          const fill = color || EColorMap.gray_0;
          return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 18C7 17.4477 7.44772 17 8 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H8C7.44772 19 7 18.5523 7 18Z"
                fill={fill}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 6C7 5.44772 7.44772 5 8 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H8C7.44772 7 7 6.55228 7 6Z"
                fill={fill}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 12C7 11.4477 7.44772 11 8 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H8C7.44772 13 7 12.5523 7 12Z"
                fill={fill}
              />
              <path d="M4 6H4.01" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M4 12H4.01" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M4 18H4.01" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          );
        })()}
      {variant === MenuIconVariant.BUBBLE_CHAT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.0418 23.9578C5.75034 25.6663 8.5002 25.6663 13.9999 25.6663C19.4996 25.6663 22.2495 25.6663 23.958 23.9578C25.6666 22.2493 25.6666 19.4994 25.6666 13.9997C25.6666 8.49995 25.6666 5.75009 23.958 4.04155C22.2495 2.33301 19.4996 2.33301 13.9999 2.33301C8.5002 2.33301 5.75034 2.33301 4.0418 4.04155C2.33325 5.75009 2.33325 8.49995 2.33325 13.9997C2.33325 19.4994 2.33325 22.2493 4.0418 23.9578ZM21.8749 18.6663C21.8749 19.1496 21.4832 19.5413 20.9999 19.5413H6.99992C6.51667 19.5413 6.12492 19.1496 6.12492 18.6663C6.12492 18.1831 6.51667 17.7913 6.99992 17.7913H20.9999C21.4832 17.7913 21.8749 18.1831 21.8749 18.6663ZM20.9999 14.8747C21.4832 14.8747 21.8749 14.4829 21.8749 13.9997C21.8749 13.5164 21.4832 13.1247 20.9999 13.1247H6.99992C6.51667 13.1247 6.12492 13.5164 6.12492 13.9997C6.12492 14.4829 6.51667 14.8747 6.99992 14.8747H20.9999ZM21.8749 9.33301C21.8749 9.81626 21.4832 10.208 20.9999 10.208H6.99992C6.51667 10.208 6.12492 9.81626 6.12492 9.33301C6.12492 8.84976 6.51667 8.45801 6.99992 8.45801H20.9999C21.4832 8.45801 21.8749 8.84976 21.8749 9.33301Z"
            fill="#ADB0B8"
          />
        </svg>
      )}
    </i>
  );
}

export default MenuIcon;
